import * as React from 'react';
import { ProfileFormContext } from '../../ProfileEditForm';
import { ACTIONS } from '../ProfileFormReducer';
import Select from 'react-select';

export default function JobTypes() {
  const [state, dispatch] = React.useContext(ProfileFormContext);
  const { job_types } = state.options
  const { profile: { job_type_ids } } = state

  const [jobTypeState, setJobTypeState] = React.useState(job_type_ids)

  // jobTypeOptions
  const jobTypeOptions = job_types.map((j) => ({
    value: j.id,
    label: j.title
  }))

  const customStyles = {
    control: (styles, { isFocused }) => ({
      ...styles,
      minHeight: '48px',
      backgroundColor: '#ffffff',
      borderColor: isFocused ? '#085ec8' : '#e2e8f0',
      borderWidth: '2px',
      borderRadius: '12px',
      boxShadow: isFocused ? '0 0 0 3px rgba(8, 94, 200, 0.15)' : 'none',
      '&:hover': {
        borderColor: '#cbd5e0'
      }
    }),
    menu: (styles) => ({
      ...styles,
      zIndex: 9999,
      borderRadius: '12px',
      border: '2px solid #e2e8f0',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      marginTop: '4px'
    }),
    menuList: (styles) => ({
      ...styles,
      padding: '8px',
      borderRadius: '10px'
    }),
    menuPortal: (styles) => ({
      ...styles,
      zIndex: 9999
    }),
    option: (styles, { isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected
          ? '#085ec8'
          : isFocused
          ? 'rgba(8, 94, 200, 0.1)'
          : 'white',
        color: isSelected ? 'white' : '#2d3748',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        '&:active': {
          backgroundColor: isSelected ? '#085ec8' : 'rgba(8, 94, 200, 0.2)'
        }
      }
    },
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: 'transparent',
      borderRadius: '50px',
      padding: '2px'
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      backgroundColor: '#085ec8',
      color: 'white',
      borderRadius: '50px 0 0 50px',
      paddingLeft: 12,
      paddingRight: 6,
      paddingTop: 6,
      paddingBottom: 6,
      fontSize: '0.9rem',
      fontWeight: 500
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      backgroundColor: '#085ec8',
      color: 'white',
      borderRadius: '0 50px 50px 0',
      paddingRight: 8,
      paddingLeft: 4,
      marginLeft: 0,
      '&:hover': {
        backgroundColor: '#034ba6',
        color: 'white'
      }
    }),
    placeholder: (styles) => ({
      ...styles,
      color: '#9ca3af',
      fontSize: '1rem'
    }),
    input: (styles) => ({
      ...styles,
      color: '#2d3748',
      fontSize: '1rem'
    })
  }

  React.useEffect(() => dispatch({
    type: ACTIONS.SET_JOB_TYPES, payload: jobTypeState
  }), [jobTypeState])

  return (
    <>
      <Select
        styles={customStyles}
        options={jobTypeOptions}
        isMulti
        placeholder="Select positions you're qualified for..."
        value={jobTypeOptions.filter((j) => jobTypeState.includes(j.value))}
        onChange={selected => {
          setJobTypeState(selected ? selected.map((j) => j.value) : [])
        }}
        className="react-select-container"
        classNamePrefix="react-select"
        menuPortalTarget={document.body}
        menuPosition="fixed"
      />
    </>
  )
}
